<!-- <button (click)="toggleFullscreen()" class="fullscreen-mode">
	{{ fullscreenService.isFullscreen() ? 'Exit Fullscreen' : 'Open Fullscreen' }}
</button> -->
@if (showAppChrome) {
<p class="printerStatus">Printer: {{ printerStatus }}</p>
<p class="version">{{ version }}</p>
}

<router-outlet></router-outlet>
